import React from 'react';

const ErrorImage = (
    <svg
        width="684"
        viewBox="0 0 684 521"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g opacity="0.05">
            <g opacity="0.05">
                <path
                    opacity="0.05"
                    d="M215.923 460.017C264.712 426.201 357.736 376.672 446.718 342.457C448.312 341.034 449.905 339.61 451.556 338.187C487.992 305.908 536.667 265.715 542.588 221.765C548.337 177.645 511.333 129.766 466.017 103.92C420.757 78.131 367.129 74.2597 313.387 74.1459C259.646 74.032 205.961 77.6186 179.147 106.767C152.503 135.858 152.902 190.625 148.86 240.552C144.818 290.48 136.221 335.739 149.258 378.038C159.79 412.822 185.124 445.842 215.923 460.017Z"
                    fill="#4B2669"
                />
            </g>
        </g>
        <path
            d="M463.739 336.251C459.071 334.6 443.643 314.333 443.643 290.195C443.643 262.185 473.247 209.184 476.093 190.226C477.915 178.214 485.999 72.3809 547.426 72.3809C580.958 72.3809 583.748 137.85 583.748 167.169C583.748 235.599 484.234 293.895 484.234 329.477C477.63 332.209 470.742 334.43 463.739 336.251Z"
            fill="#AADA94"
        />
        <path
            d="M471.31 334.77C470.684 334.77 470.172 334.257 470.172 333.631C470.172 307.842 479.565 269.414 495.221 230.816C510.82 192.388 530.347 159.482 547.483 142.802C547.938 142.346 548.621 142.403 549.077 142.802C549.532 143.257 549.532 143.941 549.077 144.396C532.168 160.906 512.869 193.526 497.327 231.67C481.728 270.04 472.449 308.127 472.449 333.688C472.449 334.257 471.936 334.77 471.31 334.77Z"
            fill="#69A0AB"
        />
        <path
            d="M283.043 418.915C286.857 415.613 265.338 310.691 246.665 292.132C226.341 271.978 209.603 261.275 204.081 254.615C194.289 242.887 188.084 198.539 144.988 198.539C133.545 198.539 106.788 207.989 101.949 247.783C100.355 260.877 97.5083 280.916 124.721 309.894C143.052 329.478 165.995 322.703 188.425 343.824C204.537 359.081 202.316 382.024 217.346 401.437C229.472 417.15 260.783 438.1 283.043 418.915Z"
            fill="#406D2C"
        />
        <path
            d="M277.748 422.615C277.122 422.615 276.609 422.103 276.609 421.477C276.609 409.635 258.335 375.876 231.179 337.562C203.227 298.166 175.673 267.823 160.985 260.365C160.415 260.08 160.188 259.397 160.472 258.828C160.757 258.259 161.44 258.031 162.009 258.315C173.965 264.407 198.843 288.09 233.001 336.253C245.639 354.072 257.082 372.062 265.223 386.863C271.429 398.192 278.83 413.336 278.83 421.477C278.886 422.103 278.374 422.615 277.748 422.615Z"
            fill="#69A0AB"
        />
        <path
            d="M205.561 469.066C205.276 469.066 205.049 468.952 204.878 468.724C204.593 468.383 204.65 467.814 205.049 467.529C237.556 442.935 296.99 409.119 360.24 379.231C434.704 343.991 504.159 319.056 555.851 308.979C556.306 308.865 556.762 309.207 556.819 309.662C556.933 310.118 556.591 310.573 556.136 310.63C504.614 320.707 435.273 345.585 360.923 380.768C297.787 410.599 238.41 444.415 206.016 468.895C205.959 469.009 205.732 469.066 205.561 469.066Z"
            fill="#6E6E6E"
        />
        <path
            d="M323.236 115.418H377.148C380.849 115.418 383.923 118.435 383.923 122.192V234.06C383.923 237.76 380.906 240.778 377.148 240.778H323.236C319.535 240.778 316.461 237.76 316.461 234.06V122.192C316.518 118.435 319.535 115.418 323.236 115.418Z"
            fill="#662483"
        />
        <path
            d="M322.267 445.729V460.36H282.586V454.211L307.18 442.882L322.267 445.729Z"
            fill="#333333"
        />
        <path
            d="M408.402 431.779C410.395 436.277 415.12 447.89 415.12 447.89L395.308 460.358H377.318L375.269 453.526L397.813 436.277L408.402 431.779Z"
            fill="#333333"
        />
        <path
            d="M339.745 70.446C348.967 70.446 356.482 79.8964 356.482 91.5101C356.482 103.124 348.967 112.574 339.745 112.574C330.522 112.574 323.007 103.124 323.007 91.5101C323.007 79.8964 330.522 70.446 339.745 70.446Z"
            fill="#8F5A3B"
        />
        <path
            d="M327.561 53.8773C325.341 50.86 319.192 51.5431 313.727 55.4713C311.621 56.9515 309.913 58.7732 308.546 60.9366C308.376 60.8797 308.148 60.8227 307.977 60.8227C301.772 60.8227 261.295 80.5774 261.807 95.1515C262.205 106.025 277.007 123.389 282.131 126.691C282.131 126.691 305.358 115.817 304.106 112.344C302.853 108.872 289.475 97.7134 287.141 95.55C289.873 94.0698 311.905 72.2657 314.41 69.8177C316.972 69.2484 319.477 68.1098 321.64 66.5727C327.163 62.5306 329.838 56.8946 327.561 53.8773Z"
            fill="#8F5A3B"
        />
        <path
            d="M314.98 145.65C320.047 141.608 311.678 107.507 302.683 106.653C293.688 105.799 278.089 122.708 278.659 127.49C279.285 132.272 302.228 155.898 314.98 145.65Z"
            fill="#595963"
        />
        <path
            d="M294.883 227.344C294.883 232.981 297.673 427.453 302.739 444.361C307.237 446.582 319.021 447.151 322.949 445.5C326.878 443.792 352.041 230.476 352.041 221.082C352.041 211.689 294.883 227.344 294.883 227.344Z"
            fill="#CC0000"
        />
        <path
            d="M395.706 438.265C390.355 429.84 320.445 266.052 314.979 225.689C320.729 221.248 363.427 214.132 366.843 222.216C370.258 230.243 411.817 429.896 410.394 432.458C409.028 435.077 399.748 439.119 395.706 438.265Z"
            fill="#E95D5D"
        />
        <path
            d="M339.972 118.837C376.236 118.837 373.959 219.205 366.102 225.353C358.246 231.558 296.648 231.786 292.72 227.346C288.848 222.848 279.569 118.837 339.972 118.837Z"
            fill="#91919B"
        />
        <path
            d="M366.387 84.3892C366.387 80.1195 362.288 77.0453 362.288 74.6542C362.288 72.3201 363.711 67.9934 360.523 64.9761C356.709 61.2757 350.617 62.8128 345.209 62.8128C340.085 62.8128 335.417 54.4441 328.471 54.4441C323.803 54.4441 320.103 53.9317 316.232 60.4787C316.232 60.4787 313.385 64.6345 313.271 72.2632C313.214 77.3869 313.385 84.2754 324.088 84.2754C324.828 81.8274 327.447 76.419 330.521 73.9711C332.115 74.6542 340.655 78.1839 342.761 78.8101C344.924 79.4363 347.998 88.5451 351.243 89.6268C354.488 90.7085 354.716 96.743 357.164 96.5153C359.498 96.2307 366.387 95.2629 366.387 84.3892Z"
            fill="#211F42"
        />
        <path
            d="M352.44 89.1188C354.66 88.151 357.279 89.1757 358.304 91.396C359.271 93.6163 358.247 96.2351 356.026 97.2598C353.749 98.2276 351.187 97.2029 350.162 94.9826C349.195 92.7054 350.22 90.0866 352.44 89.1188Z"
            fill="#8F5A3B"
        />
        <path
            d="M348.17 126.749C347.43 129.197 332.571 126.236 332.856 123.504L335.361 98.9669L353.294 102.838C353.294 102.724 348.853 124.301 348.17 126.749Z"
            fill="#8F5A3B"
        />
        <path
            d="M386.541 453.581C386.427 453.581 386.256 453.581 386.142 453.524C385.061 453.296 384.378 452.272 384.605 451.247L447.513 139.498C447.741 138.417 448.765 137.733 449.79 137.961C450.872 138.189 451.555 139.214 451.327 140.238L388.419 451.987C388.306 452.955 387.452 453.581 386.541 453.581Z"
            fill="#662483"
        />
        <path
            d="M437.949 224.497C436.241 222.789 434.134 221.708 431.743 221.252C424.285 209.183 398.724 171.837 387.509 158.288C379.424 164.151 369.519 174.228 369.519 174.228C373.618 178.839 404.588 215.502 421.097 229.849C421.097 232.866 422.293 235.826 424.456 237.933C428.612 242.089 435.045 242.487 438.745 238.787C442.446 235.029 442.104 228.71 437.949 224.497Z"
            fill="#8F5A3B"
        />
        <path
            d="M354.262 135.343C368.836 124.527 392.746 150.715 392.348 157.546C391.949 164.378 373.504 179.692 367.242 179.692C359.556 179.692 341.908 144.509 354.262 135.343Z"
            fill="#91919B"
        />
    </svg>
);

export default ErrorImage;
